// leave off @2x/@3x
import arrowBack from '../resources/image/back@1.5x.png';
import currentPin from '../resources/image/current_pin.png';
import gps from '../resources/image/gps.png';
import overviewImage from '../resources/image/Googlebusiness.png';
import success from '../resources/image/success.png';
import unsuccess from '../resources/image/unsuccess.png';
import empty from '../resources/image/empty.png';
import error from '../resources/image/error.png';
import deletes from '../resources/image/delete.png';
import down from '../resources/image/down.png';
import check from '../resources/image/check.png';
import stop from '../resources/image/stop.png';
import edit from '../resources/image/edit.png';
import iconLoading from '../resources/image/icon-loading-flower.gif';
import step1 from '../resources/image/landing/step1.png';
import step2 from '../resources/image/landing/step2.png';
import step3 from '../resources/image/landing/step3.png';
import step4 from '../resources/image/landing/step4.png';
import step5 from '../resources/image/landing/step5.png';
import step6 from '../resources/image/landing/step6.png';
import alert from '../resources/image/alert.png';
import redAlert from '../resources/image/red-alert.png';
import logo from '../resources/image/logo.png';
import branchdefault from '../resources/image/branchdefault.png';
import menudefault from '../resources/image/menudefault.png';
import menudefault2 from '../resources/image/menudefault2.png';
import menuTableDefault from '../resources/image/menuTableDefault.jpg';
import productDefault from '../resources/image/productDefault.png';
import productDefault2 from '../resources/image/productDefault2.png';
import menuIcon from '../resources/image/menuIcon.png';
import promotion from '../resources/image/promotion.png';
import bg from '../resources/image/landing/bg.png';
import logoIcon from '../resources/image/logo_icon.png';
import back from '../resources/image/back.png';
import close from '../resources/image/close.png';
import posIcon from '../resources/image/posIcon.png';
import asterisk from '../resources/image/asterisk.png';
import chef from '../resources/image/chef.png';
import mainMart from '../resources/image/main-mart.png';
import emptyState from '../resources/image/emptyState.png';
import foodIcon from '../resources/image/food_icon.png';
import martIcon from '../resources/image/mart_icon.png';

const images = {
  arrowBack,
  overviewImage,
  gps,
  currentPin,
  success,
  unsuccess,
  empty,
  error,
  down,
  deletes,
  check,
  stop,
  edit,
  iconLoading,
  landingStep: {
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
  },
  alert,
  logo,
  branchdefault,
  menudefault,
  menudefault2,
  menuTableDefault,
  menuIcon,
  promotion,
  bg,
  logoIcon,
  back,
  close,
  posIcon,
  asterisk,
  redAlert,
  chef,
  mainMart,
  emptyState,
  productDefault,
  productDefault2,
  foodIcon,
  martIcon,
};

export default images;
